module.exports = __webpack_public_path__ + "static/media/lensfest.841e886b.jpg";